exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".waiting_list_quantity[data-v-5becf6bb]{background-color:#ccc;border-radius:50%;width:25px;height:25px;display:inline-flex;justify-content:center;align-items:center;font-size:16px}.form-group.disabled[data-v-5becf6bb]{opacity:.35;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5becf6bb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/app/pages/order/Filter.vue
// module id = 140
// module chunks = 0